import './App.css';
import Home from './components/Home/Home/Home';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import AllProject from './components/AllProject/AllProject';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Project from './components/Projects/Project/Project';
import About from './components/About/About';
import Blogs from './components/Blogs/Blogs';
import ScrollToTop from "react-scroll-to-top";
import MessengerCustomerChat from 'react-messenger-customer-chat';
import ScrollTop from './components/ScrollTop/ScrollTop';
import Navigation from './components/Home/Navbar/Navbar';

function App() {
  return (
    <div className="App">
      <Router>
        <Navigation></Navigation>
        <MessengerCustomerChat
          pageId="111697531354846"
          appId="1749364141916080"
          style={{

          }}
        />
        <ScrollTop />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/blogs">
            <Blogs />
          </Route>
          <Route path="/projects">
            <AllProject />
          </Route>
          <Route path="/project/:projectId">
            <Project />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
        </Switch>
        <ScrollToTop smooth="true"
          color="white"
          width="28"
          style={{
            background: "linear-gradient(to right, rgb(255, 180, 0), rgb(255, 115, 0))",
            fontWeight: "bold",
            marginTop: "60px"
          }}
        ></ScrollToTop>
        <Footer />
      </Router>
    </div >
  );
}

export default App;
